import { getSessionStorage } from '/@/utils/storage'

// 进入后台前检查是否已开通套餐，未开通则跳转到套餐选择页
export default async(to, from, next) => {
  // 白名单：登录页与套餐选择页不拦截
  const white = ['/login', '/plan-gate']
  if (white.includes(to.path)) return next()

  // 获取用户信息，判断是否为超级管理员
  const userInfo = getSessionStorage('userInfo')
  console.log('checkPlan.js - 用户信息:', userInfo)
  // 超级管理员跳过套餐检查，直接放行
  if (userInfo && userInfo.role === 'super_admin') {
    console.log('checkPlan.js - 检测到超级管理员，直接放行')
    return next()
  }

  // 获取系统配置，判断是否允许直接进入首页
  const system = getSessionStorage('system')
  const allowDirectHome = system && system.login_redirect_home === 1

  // 仅对需要登录的后台页面进行套餐校验（meta.needLogin 在 routes.js 已统一设置）
  if (to.meta && to.meta.needLogin) {
    const userPlan = getSessionStorage('userPlan')

    // 如果系统配置允许直接进入首页，且目标页面是首页，则允许访问
    if (allowDirectHome && to.path === '/home') {
      return next()
    }

    // 若没有缓存的套餐信息或状态非 active，则统一跳转套餐页
    if (!userPlan || userPlan.status !== 'active') {
      if (to.path !== '/plan-gate') {
        return next({ path: '/plan-gate', query: { redirect: to.fullPath }})
      }
    }
  }
  next()
}
